const { REACT_APP_ENV = 'DEV' } = process.env || {};
const ENV = REACT_APP_ENV;
export { ENV };
